import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { authMe } from "@/lib/api";

export default function AuthGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking"); // "checking" | "ok" | "invalid"

  useEffect(() => {
    const token = localStorage.getItem("pm_token");
    if (!token) {
      setStatus("invalid");
      return;
    }
    authMe()
      .then(() => setStatus("ok"))
      .catch(() => {
        localStorage.removeItem("pm_token");
        localStorage.removeItem("pm_user");
        setStatus("invalid");
      });
  }, [navigate]);

  if (status === "checking") {
    // Blank screen while validating — prevents flash of protected content
    return <div className="min-h-screen bg-background" />;
  }

  if (status === "invalid") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
